import React from 'react';
import { Button } from 'components/ui';
import { wrapFunctionalComponent } from 'utils/framework';
import { IconImage } from 'ai/components/SuperChat/SuperChatHeader';
import { fontWeights, space, colors } from 'style/config';
import { isGenAINewUIEnabledWithRCPS } from 'ai/utils/aiBeautyChat';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import EN from 'ai/components/SuperChat/locales/SuperChat_en_US';
import FR from 'ai/components/SuperChat/locales/SuperChat_fr_CA';

const { getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(EN, FR);

function FeedbackButtonMobile({ iconSrc, onIconClick, showFlyer }) {
    const isGenAINewUIEnabled = isGenAINewUIEnabledWithRCPS();

    return (
        <Button
            variant='special'
            onClick={onIconClick}
            css={[styles.headerButton, styles.feedbackButtonMobile]}
            display={['flex', 'none', 'none']}
        >
            {isGenAINewUIEnabled && !showFlyer ? <span>{getText('feedback')}</span> : <IconImage src={iconSrc} />}
        </Button>
    );
}

const styles = {
    headerButton: {
        minWidth: space[5],
        minHeight: space[5],
        height: space[5],
        width: space[5],
        padding: space[0],
        cursor: 'pointer',
        border: 'none',
        background: 'transparent',
        alignItems: 'center',
        justifyContent: 'center',
        color: colors.darkGray,
        '&:hover': {
            background: 'transparent !important',
            color: colors.darkGray
        }
    },
    feedbackButtonMobile: {
        fontWeight: fontWeights.normal,
        left: space[4] + space[1],
        position: 'relative'
    }
};

export default wrapFunctionalComponent(FeedbackButtonMobile, 'FeedbackButtonMobile');
